<div class="hmn-unit-details-header hmn-row__space">
  <app-unit-details-header-title class="hmn-hidden__before-lg"></app-unit-details-header-title>
  <app-unit-details-header-controls
    (month_change)="month_change.emit($event)"
    (year_change)="year_change.emit($event)"></app-unit-details-header-controls>
</div>
